/* globals braintree */
const initBraintreeClient = token => braintree.client.create({ authorization: token });

export default initBraintreeClient;
